<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y8PCRl/tc-custom/9781035816859.jpg?1716906352577" alt="This image is the cover for the book Murder Make$ The World Go Round"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder Make$ The World Go Round
      </h1>
      <p class="bookDescription body article font2">
        <p>A light hearted, tongue in cheek, and at times hilarious murder mystery set in the international art world. Centred around the oldest auction house in London, Mount’s, the reader meets a cast of fascinating characters. When the Home Secretary appoints the new Head of the Art Squad, she is encouraged to investigate the deaths of a number of clients over the last six years. Travelling around the world with her intern, who is also the Home Secretary’s nephew, she uncovers all the stories behind each of the deaths. They meet all sorts of people and experience many new things but struggle at the end of the day to get to the bottom of what is going on despite trying. Assisted by a number of amateurs, who actually work out a couple of key clues, she believes that she has got to the bottom of the deaths.  When some surprising information comes to light, the whole art world is traumatised.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clive Graham Lord
      </h2>
      
      <p class="authorDescription body article">Clive worked at Sotheby’s for 22 years, 15 as Chief Operating Officer. Many of the incidents, apart from the murders, of course, are based on real-life experiences and have been woven into this book with a little added literary license. This is Clive’s first novel since moving on from Sotheby’s, and he lives in London and Surrey with his partner.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ebb7442e